var base = require('settings/teams/current-teams');

Vue.component('spark-current-teams', {
    mixins: [base],

    methods: {
        exportData() {
        	console.log("EXPORT DATA");
            axios.get(`/api/export`)
                .then(response => {})
		        .catch(error => {
		        	console.log(error);
		        });
        },
    }
});
